$(document).ready(function(){
    var quotesSlider = new Swiper(".quotes_slider", {
        autoHeight: true,
        effect: 'fade',
        loop: true,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    });

    // Optimalisation: Store the references outside the event handler:
    var $window = $(window);

    function checkWidth() {
        var windowsize = $window.width();
        if (windowsize < 750) {
            $(".announcement-bar__message").slick({
                speed: 10000,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                dots: false,
                prevArrow: false,
                nextArrow: false,
                slidesToShow: 1.4,
                slidesToScroll: 1,
                infinite: true,
                swipeToSlide: true,
                centerMode: true,
                focusOnSelect: true,
                touchMove: false,
                draggable: false,
                accessibility: false,
            });
        }
    }

    // Execute on load
    checkWidth();
    // Bind event listener
    $(window).resize(checkWidth);

})